import { Component, OnInit } from "@angular/core";

import "../faw-supplier-styles.css"; //App-wide styles

@Component({
    selector: "faw-supplier-app",
    template: require('./app.component.html'),
    //styles: [require('./app.component.css')]
})

export class AppComponent implements OnInit {
    constructor() { }

    ngOnInit() {

    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/app.component.ts